import { getAxiosBackendApi } from "../helpers/axios"

class MartyrServices{

    constructor(){
    }

    addMartyr(data){
        return getAxiosBackendApi().post('martyrs', data)
    }
}

export default new MartyrServices()